/* eslint-disable react/no-array-index-key */

/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable no-restricted-syntax */
import React from 'react';
import { func, number, oneOfType, string } from 'prop-types';
import BootstrapPagination from 'react-bootstrap/Pagination';

import exportWithBoundary from '../helpers/exportWithBoundary';

function Pagination(props) {
  const { total, perPage, page, setPage, maxPage, className } = props;

  // eslint-disable-next-line radix
  const currentPage = parseInt(page);
  if (Number.isNaN(currentPage)) return null;

  let pages = 0;

  if (maxPage) {
    pages = maxPage;
  } else if (total > 0 && perPage > 0) {
    pages = Math.ceil(total / perPage);
  }

  const showPagination = pages > 1;
  let firstDisplay = currentPage - 2;
  let lastDisplay = currentPage + 2;
  if (firstDisplay < 2) {
    firstDisplay = 2;
    lastDisplay = Math.min(5, pages - 1);
  }
  if (lastDisplay > pages - 1) {
    lastDisplay = pages - 1;
    firstDisplay = Math.max(2, lastDisplay - 4);
  }
  const innerPages = [];
  if (pages > 9 && currentPage > 4) {
    innerPages.push(
      <BootstrapPagination.Ellipsis key='pagination_ellipsis_1' />
    );
  }
  for (let i = firstDisplay; i <= lastDisplay; i += 1) {
    innerPages.push(
      <BootstrapPagination.Item
        key={`pagination_${i}`}
        active={currentPage === i}
        onClick={() => setPage(i)}
      >
        {i}
      </BootstrapPagination.Item>
    );
  }
  if (pages > 9 && currentPage < pages - 3) {
    innerPages.push(
      <BootstrapPagination.Ellipsis key='pagination_ellipsis_2' />
    );
  }

  return (
    showPagination && (
      <BootstrapPagination className={`${className} pagination-flat`}>
        <BootstrapPagination.First
          key='pagination_first'
          onClick={() => setPage(1)}
        />
        <BootstrapPagination.Prev
          key='pagination_prev'
          disabled={currentPage <= 1}
          onClick={() => setPage(currentPage - 1)}
        />
        <BootstrapPagination.Item
          key='pagination_1'
          active={currentPage === 1}
          onClick={() => setPage(1)}
        >
          {1}
        </BootstrapPagination.Item>
        {innerPages}
        <BootstrapPagination.Item
          key={`pagination_${pages}`}
          active={currentPage === pages}
          onClick={() => setPage(pages)}
        >
          {pages}
        </BootstrapPagination.Item>
        <BootstrapPagination.Next
          key='pagination_next'
          disabled={currentPage === pages}
          onClick={() => setPage(currentPage + 1)}
        />
        <BootstrapPagination.Last
          key='pagination_last'
          onClick={() => setPage(pages)}
        />
      </BootstrapPagination>
    )
  );
}

Pagination.defaultProps = {
  total: 0,
  className: '',
  maxPage: null,
};

Pagination.propTypes = {
  total: number,
  perPage: number.isRequired,
  page: oneOfType([number, string]).isRequired,
  setPage: func.isRequired,
  maxPage: number,
  className: string,
};

function PaginationFallback() {
  return <span />;
}

export default exportWithBoundary(Pagination, PaginationFallback);
